import { render, staticRenderFns } from "./product-supliers-details.vue?vue&type=template&id=79a8aa1e&scoped=true"
import script from "./product-supliers-details.vue?vue&type=script&lang=js"
export * from "./product-supliers-details.vue?vue&type=script&lang=js"
import style0 from "./product-supliers-details.vue?vue&type=style&index=0&id=79a8aa1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a8aa1e",
  null
  
)

export default component.exports